module.exports = __webpack_public_path__ + "static/media/kaporg-logo-blue.87ab24cc.svg";